import { FC, ReactNode, useEffect } from 'react';

import { Footer, Header, UserCentric } from '@catawiki/layout';

import { isInMobileApp } from '@/shared/utils/isInMobileApp';
import { usePagesRuntimeConfig } from '@/shared/utils/runtimeConfig';
import { HeaderSettings, PagesTheme } from '@/shared/models/header';
import { isInBuilder } from '@/shared/utils/isInBuilder';

interface Props extends HeaderSettings {
  children: ReactNode;
}

export const Layout: FC<Props> = ({ theme, children }) => {
  const inApp = isInMobileApp();
  const insideBuilder = isInBuilder();
  const runtimeConfig = usePagesRuntimeConfig();
  const runtimeEnvironment = runtimeConfig.stage ?? runtimeConfig.environment;
  const environment = runtimeEnvironment ?? 'production';

  useEffect(() => {
    if (inApp) {
      document.body.classList.remove('tw:header-offset');
    }
  }, [inApp]);

  return (
    <div className="u-typography-body">
      {inApp ? null : (
        <Header
          environment={environment}
          variant={theme === PagesTheme.FOCUSED ? 'focused' : 'buyer'}
        />
      )}
      {children}
      {inApp ? null : <Footer />}
      {inApp || insideBuilder || runtimeEnvironment !== 'production' ? null : (
        <UserCentric />
      )}
    </div>
  );
};
